import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { ScrollTextIcon, SearchIcon, AlertTriangleIcon } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
import { Tabs } from '../../components/ui/Tabs';
import { DataTable } from '../../components/ui/DataTable';
import { formatDateTime } from '../../lib/formatters';
import { MOCK_AUDIT_LOGS } from '../../lib/mockData';
import type { AuditLog } from '../../lib/types';
export function AuditLogsPage() {
  const [search, setSearch] = useState('');
  const [activeTab, setActiveTab] = useState('all');
  const flaggedCount = MOCK_AUDIT_LOGS.filter(l => l.isFlagged).length;
  const tabs = [{
    id: 'all',
    label: 'Tất cả',
    count: MOCK_AUDIT_LOGS.length
  }, {
    id: 'flagged',
    label: 'Cảnh báo',
    count: flaggedCount
  }, {
    id: 'adjustment',
    label: 'Điều chỉnh'
  }, {
    id: 'login',
    label: 'Đăng nhập'
  }];
  const filtered = useMemo(() => {
    let logs = MOCK_AUDIT_LOGS;
    if (activeTab === 'flagged') logs = logs.filter(l => l.isFlagged);else if (activeTab !== 'all') logs = logs.filter(l => l.actionType === activeTab);
    if (search) {
      const q = search.toLowerCase();
      logs = logs.filter(l => l.action.toLowerCase().includes(q) || l.staffName.toLowerCase().includes(q) || l.details.toLowerCase().includes(q));
    }
    return logs;
  }, [activeTab, search]);
  const actionTypeLabels: Record<string, string> = {
    create: 'Tạo mới',
    update: 'Cập nhật',
    delete: 'Xóa',
    login: 'Đăng nhập',
    adjustment: 'Điều chỉnh',
    approval: 'Phê duyệt'
  };
  const actionTypeVariants: Record<string, 'success' | 'info' | 'warning' | 'error' | 'default' | 'gold'> = {
    create: 'success',
    update: 'info',
    delete: 'error',
    login: 'default',
    adjustment: 'warning',
    approval: 'gold'
  };
  const columns = [{
    key: 'time',
    header: 'Thời gian',
    render: (l: AuditLog) => <span className="text-xs text-[#B0B0B0] whitespace-nowrap" data-id="element-658">
          {formatDateTime(l.createdAt)}
        </span>
  }, {
    key: 'staff',
    header: 'Nhân viên',
    render: (l: AuditLog) => <span className="text-sm text-white" data-id="element-659">{l.staffName}</span>
  }, {
    key: 'action',
    header: 'Hành động',
    render: (l: AuditLog) => <div data-id="element-660">
          <p className="text-sm text-white" data-id="element-661">{l.action}</p>
          <p className="text-xs text-[#666666] truncate max-w-[300px]" data-id="element-662">
            {l.details}
          </p>
        </div>
  }, {
    key: 'type',
    header: 'Loại',
    render: (l: AuditLog) => <Badge variant={actionTypeVariants[l.actionType]} size="sm" data-id="element-663">
          {actionTypeLabels[l.actionType]}
        </Badge>
  }, {
    key: 'flag',
    header: '',
    render: (l: AuditLog) => l.isFlagged ? <AlertTriangleIcon className="w-4 h-4 text-[#EF4444]" data-id="element-664" /> : null
  }];
  return <div data-id="element-665">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-666">
        <h1 className="text-2xl font-bold text-white mb-1 flex items-center gap-3" data-id="element-667">
          <ScrollTextIcon className="w-7 h-7 text-[#C8A84E]" data-id="element-668" />
          Nhật Ký Hệ Thống
        </h1>
        <p className="text-sm text-[#666666] mb-6" data-id="element-669">
          Theo dõi tất cả hoạt động trong hệ thống
        </p>
      </motion.div>

      {flaggedCount > 0 && <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-4 bg-[#EF4444]/10 border border-[#EF4444]/20 rounded-xl p-3 flex items-center gap-2" data-id="element-670">
          <AlertTriangleIcon className="w-4 h-4 text-[#EF4444]" data-id="element-671" />
          <span className="text-sm text-[#EF4444]" data-id="element-672">
            {flaggedCount} hoạt động bất thường cần kiểm tra
          </span>
        </motion.div>}

      <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} className="mb-4" data-id="element-673" />

      <div className="mb-4" data-id="element-674">
        <Input placeholder="Tìm kiếm nhật ký..." value={search} onChange={e => setSearch(e.target.value)} leftIcon={<SearchIcon className="w-4 h-4" data-id="element-676" />} data-id="element-675" />
      </div>

      <Card padding="none" data-id="element-677">
        <DataTable columns={columns} data={filtered} keyExtractor={l => l.id} emptyMessage="Không tìm thấy nhật ký" data-id="element-678" />
      </Card>
    </div>;
}